import { render, staticRenderFns } from "./ClientDetailsModal.vue?vue&type=template&id=dc868de8&scoped=true"
import script from "./ClientDetailsModal.vue?vue&type=script&lang=js"
export * from "./ClientDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./ClientDetailsModal.vue?vue&type=style&index=0&id=dc868de8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc868de8",
  null
  
)

export default component.exports